module.exports = __webpack_public_path__ + "static/8-604e45d2f12ed3e4fd3f9da989b59ce9.jpg";